import {Text, VStack} from "@hosttools/frontend/components";
import type {Listing} from "@hosttools/frontend/models/listing";
import type React from "react";
import {memo} from "react";

import ListingImages from "./ListingImages";

import ListingChannels from "@/client/components/Settings/Listings/ListingChannels";

type Props = {
    listing: Listing;
};

const ConnectedListingItem: React.FC<Props> = ({listing}) => {
    return (
        <VStack
            className={`
                border-1 border-solid border-blueGray-200 p-4 rounded-lg
            `}
            space="md"
        >
            <ListingImages listing={listing} />
            <Text isTruncated color="blueGray.800" variant="sm">
                {listing.name}
            </Text>
            <Text isTruncated color="blueGray.600" variant="xs">
                {listing.airbnbAddress}
            </Text>
            <ListingChannels canRemoveChannel={false} listing={listing} />
        </VStack>
    );
};

export default memo(ConnectedListingItem);
